module.exports = __webpack_public_path__ + "img/cover.2006bc74.jpg";